import React, { useState, useEffect, useMemo } from 'react';
import { MenuItem } from '@mui/material';
import CustomSelect from '../../../components/common/SelectField';

interface ProcessStageSelectProps {
  process: any;
  setRender: any;
  isRowDisable: any;
  isView: any;
  defectStages?: any[];
}

const ProcessStageSelect = ({
  process,
  setRender,
  isRowDisable,
  isView,
  defectStages = [],
}: ProcessStageSelectProps) => {
  const [currentValue, setCurrentValue] = useState('');

  useEffect(() => {
    setCurrentValue(process?.stage ? process.stage.trim().toLowerCase() : '');
  }, [process?.stage]);

  const handleChange = (e: any) => {
    const newValue = e.target.value;
    process.stage = newValue; // Store the selected value as-is in process.stage
    setCurrentValue(newValue.trim().toLowerCase());
    setRender((prev: any) => !prev);
  };

  // Generate menuItems from API data
  const menuItems = useMemo(() => {
    const items = [{ value: '', label: 'None' }];
    if (defectStages && defectStages.length > 0) {
      defectStages.forEach((stage: any) => {
        if (stage.name) {
          items.push({
            value: stage.name.trim().toLowerCase(),
            label: stage.name,
          });
        }
      });
    }
    return items;
  }, [defectStages]);

  // Create regex pattern from menuItems values
  const optionsPattern = useMemo(() => {
    const values = menuItems.map((item) => item.value).join('|');
    return new RegExp(`^(${values})$`);
  }, [menuItems]);

  return (
    <CustomSelect
      name={'stage'}
      value={currentValue}
      sx={{ width: '250px' }}
      onChange={handleChange}
      disabled={isRowDisable || isView}
    >
      {optionsPattern.test(currentValue) ? (
        menuItems.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))
      ) : (
        <>
          <MenuItem value={currentValue}>
            {process?.stage || currentValue}
          </MenuItem>
          {menuItems.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </>
      )}
    </CustomSelect>
  );
};

export default ProcessStageSelect;
